export default {
  'promotionManagement.title': 'Promotions',
  'promotionManagement.section.quickAccess': 'Quick Access',
  'promotionManagement.section.allPromotions': 'All Promotions',
  'promotionManagement.edit.title': 'Edit Promotion',
  'promotionManagement.create.title': 'Create Promotion',
  'promotionManagement.duplicate.title': 'Duplicate Promotion',
  'promotionManagement.section.generalInformation': 'General Information',
  'promotionManagement.section.usageRules': 'Usage Rules',
  'promotionManagement.section.conditions': 'Conditions',
  'promotionManagement.section.schedulingAndDuration': 'Scheduling & Duration',
  'promotionManagement.column.number': 'ID Number',
  'promotionManagement.column.type': 'Promotion Type',
  'promotionManagement.column.available_count': 'Available',
  'promotionManagement.column.redeemed_count': 'Redeemed',
  'promotionManagement.column.orders_total': 'Orders Total ($)',
  'promotionManagement.column.orders_count': 'Orders Count',
  'promotionManagement.column.promotions_total': 'Promotion Total ($)',
  'promotionManagement.column.promotion_display_status': 'Status',
  'promotionManagement.column.action': 'Action',
  'promotionManagement.column.created_at': 'Created',
  'promotionManagement.column.updated_at': 'Last Updated',
  'promotionManagement.column.name': 'Promotion Name',
  'promotionManagement.column.foreign_name': 'Foreign Promotion Name',
  'promotionManagement.column.display_name': 'Display Name',
  'promotionManagement.column.display_name.tooltip':
    'Displayed on bills and receipts, as well as kiosk, QR code, and tablets',
  'promotionManagement.column.display_foreign_name': 'Foreign Display Name',
  'promotionManagement.column.description': 'Description',
  'promotionManagement.column.description.tooltip': 'Displayed on kiosk, QR code, and tablets',
  'promotionManagement.column.quantity': 'Total Quantity',
  'promotionManagement.column.quantity.description': 'Total number of promotions available for use',
  'promotionManagement.column.unlimited': 'Unlimited',
  'promotionManagement.column.limit_per_order': 'Limit per Order',
  'promotionManagement.column.limit_per_order.description':
    'Limit how many times 1 promotion can be applied to 1 order.',
  'promotionManagement.column.service_types': 'Service Type(s)',
  'promotionManagement.column.order_sources': 'Order Source(s)',
  'promotionManagement.column.customer_groups': 'Customer Group(s)',
  'promotionManagement.column.customer_groups.description':
    'Loyalty member-only promotions are limited to POS App currently.',
  'promotionManagement.column.promotion_type': 'Promotion Type',
  'promotionManagement.column.purchase_item_quantity': 'Purchase Quantity',
  'promotionManagement.column.offer_item_quantity': 'Offer Quantity',
  'promotionManagement.column.max_offer_quantity': 'Maximum Offer Quantity',
  'promotionManagement.column.miminum_amount': 'Minimum Amount',
  'promotionManagement.column.amount_off': 'Amount Off',
  'promotionManagement.column.items_excluded_from_discount': 'Items excluded from discount',
  'promotionManagement.column.items_excluded_from_discount.description':
    'Items excluded from discount in Menu Management remain valid here, but are not displayed blow',
  'promotionManagement.seleceted.desc': '({count} items selected)',
  'promotionManagement.column.eligible_items_for_promotion': 'Eligible items for promotion',
  'promotionManagement.eligibleItemsForDiscount': 'Eligible Items for discount',
  'promotionManagement.column.eligible_purchase_items': 'Eligible purchase items',
  'promotionManagement.column.eligible_offer_items': 'Eligible offer items',
  'promotionManagement.column.eligible_offer_items.description': 'Discount is applied to the cheapest item',
  'promotionManagement.eligibleOfferItemsIdenticalAsEligiblePurchaseItems':
    'List of eligible purchase & offer items are the same',
  'promotionManagement.canOnlyBuyIdenticalPurchaseAndOfferItems': 'Diner can only buy identical purchase & offer items',
  'promotionManagement.column.start_date': 'Start Date',
  'promotionManagement.column.end_date': 'End Date',
  'promotionManagement.column.days_of_week': 'Days of Week',
  'promotionManagement.column.start_time': 'Start Time',
  'promotionManagement.column.end_time': 'End Time',
  'promotionManagement.rule.required': 'Required field to publish',
  'promotionManagement.amount_off.required': 'Must select $ off or % off & fill in amount',
  'promotionManagement.customer_groups.all': 'All',
  'promotionManagement.customer_groups.loyalty_members': 'Loyalty Members',
  'promotionManagement.customer_groups.non_members': 'Non-Members',
  'promotionManagement.items.required': 'Select at least one item from any menu.',
  'promotionManagement.action.saveAsDraft': 'Save as Draft',
  'promotionManagement.action.publish': 'Publish',
  'promotionManagement.items': 'Items ( {count} / {total} )',
  'promotionManagement.openPriceItemsExcluded': 'Open price items are excluded',
  'promotionManagement.pointedItemsExcludes': 'Pointed items are excluded',
  'promotionManagement.excludedFromDiscount': 'Already excluded via Menu',
  'promotionManagement.autoPauseDesc':
    'The promotional products have been sold out. Increase the activity limit, publish again',

  'promotionManagement.searchByName': 'Promotion name',
  'promotionManagement.error.start_date': 'Start date should be before end date',
  'promotionManagement.error.end_date': 'End date should be after start date',
  'promotionManagement.error.start_time': 'Start time should be before end time',
  'promotionManagement.error.end_time': 'End time should be after start time',
  'promotionManagement.orderSourcesForEligibleItems':
    'Fill out Order Source(s) in order to select eligible promotion items.',
  'promotionManagement.orderSourcesForExcludedItems':
    'Fill out Order Source(s) in order to select items to exclude from promotion.',
  'promotionManagement.saveAsDraftSuccess': 'Successfully saved promotion. Do not forget to publish!',
  'promotionManagement.publishedSuccess': 'Successfully published promotion',
  'promotionManagement.deletePromotion': `
    Are you sure you want to delete “{promotionName}”?\nThis promotion will be deleted immediately. You cannot undo this action.
  `,
  'promotionManagement.displayPromotionsAsTheFirstCategory': 'Create and display Promotions as the first category',
  'promotionManagement.displayPromotionsAsTheFirstCategory.description': `
      <p>
        System will automatically create a category that is participating in dish-level promotions
      </p>
      <p style="margin-bottom: 0;">
        Displayed on kiosk, QR, and tablets
      </p>
    `,
  'promotionManagement.failedToLoadDishes': 'Failed to load dishes',
  'promotionManagement.singlePromotionAtTheSameTime':
    'Please do not set up multiple promotions within the same time period.',
  'promotionManagement.cannotCreatePromotion.title': 'Can not create new promotion',
  'promotionManagement.existConflicts.title': 'There are conflicts in the time period',

  'promotionManagement.generalInformation.title': 'General Information',
  'promotionManagement.generalInformation.promotion_name': 'Promotion Name',
  'promotionManagement.generalInformation.promotion_name.desc':
    'Used for promotion management and will not be displayed in the user interface.',
  'promotionManagement.generalInformation.promotion_name.english': 'English',
  'promotionManagement.generalInformation.promotion_name.foreign': 'Foreign',
  'promotionManagement.generalInformation.display_name': 'Display Name',
  'promotionManagement.generalInformation.display_name.desc':
    'Displayed on bills, receipts, and the customer self-service ordering interface.',
  'promotionManagement.generalInformation.display_name.english': 'English',
  'promotionManagement.generalInformation.display_name.foreign': 'Foreign',
  'promotionManagement.generalInformation.description': 'Description',
  'promotionManagement.generalInformation.description.desc': 'Displayed on customer self-service ordering interfaces.',
  'promotionManagement.generalInformation.description.english': 'English',
  'promotionManagement.generalInformation.description.foreign': 'Foreign',

  'promotionManagement.applicability.title': 'Applicability',
  'promotionManagement.applicability.service_types': 'Service Types',
  'promotionManagement.applicability.service_types.option.dine_in': 'Dine in',
  'promotionManagement.applicability.service_types.option.take_out': 'Take out',
  'promotionManagement.applicability.service_types.option.delivery': 'Delivery',
  'promotionManagement.applicability.order_sources': 'Order Sources',
  'promotionManagement.applicability.order_sources.desc':
    'Order discounts currently available only for walk in, online ordering, call in, branded App.',
  'promotionManagement.applicability.order_sources.option.online': 'Online Ordering',
  'promotionManagement.applicability.order_sources.option.walk_in': 'Walk in',
  'promotionManagement.applicability.order_sources.option.call_in': 'Call in',
  'promotionManagement.applicability.order_sources.option.branded_app': 'Branded App',
  'promotionManagement.applicability.user_range': 'User Range',
  'promotionManagement.applicability.user_range.option.all_users': 'All users',
  'promotionManagement.applicability.user_range.option.designated_users': 'Designated users',
  'promotionManagement.applicability.user_range.option.designated_users.download_excel_template':
    'Download excel template',
  'promotionManagement.applicability.user_range.option.designated_users.upload_user_list': 'Upload user list',

  'promotionManagement.promotionTerms.title': 'Promotion Terms',
  'promotionManagement.promotionTerms.amount_off': 'Amount Off',
  'promotionManagement.promotionTerms.maximum_discount_per_order': 'Maximum Discount per Order',

  'promotionManagement.usageRules.title': 'Usage Rules',
  'promotionManagement.usageRules.promo_code': 'Promo Code',
  'promotionManagement.usageRules.promo_code.max_characters': 'Max length: 15 characters.',
  'promotionManagement.usageRules.usage_limit_per_person': 'Usage Limit per Person',
  'promotionManagement.usageRules.usage_limit_per_person.option.limit_total_promotions_during_active_campaign_period':
    'Limit total promotions during active campaign period',
  'promotionManagement.usageRules.usage_limit_per_person.option.limit_promotions_per_calendar_week':
    'Limit promotions per calendar week',
  'promotionManagement.usageRules.usage_limit_per_person.option.limit_promotions_per_calendar_month':
    'Limit promotions per calendar month',
  'promotionManagement.usageRules.usage_limit_per_person.option.unlimited': 'Unlimited',
  'promotionManagement.usageRules.quota.min': 'Please enter a number greater than 0',
  'promotionManagement.usageRules.input.desc':
    'The system will validate the number of discounts used based on the customer’s phone number.',

  'promotionManagement.promotionPeriod.title': 'Promotion Period',
  'promotionManagement.promotionPeriod.title.desc':
    'Please do not set up multiple promotions within the same time period.',
  'promotionManagement.promotionPeriod.start_and_end': 'Start and End Dates',
  'promotionManagement.promotionPeriod.days_of_week_available': 'Days of Week Available',
  'promotionManagement.promotionPeriod.days_of_week_available.monday': 'Mon',
  'promotionManagement.promotionPeriod.days_of_week_available.tuesday': 'Tue',
  'promotionManagement.promotionPeriod.days_of_week_available.wednesday': 'Wed',
  'promotionManagement.promotionPeriod.days_of_week_available.thursday': 'Thu',
  'promotionManagement.promotionPeriod.days_of_week_available.friday': 'Fri',
  'promotionManagement.promotionPeriod.days_of_week_available.saturday': 'Sat',
  'promotionManagement.promotionPeriod.days_of_week_available.sunday': 'Sun',
  'promotionManagement.promotionPeriod.valid_hours': 'Valid Hours',

  'promotionManagement.newPromotion.banner.title': 'Promotions attract customers and boost revenue.',
  'promotionManagement.newPromotion.banner.description1':
    'Use diverse promotions to boost order volume, average spending, and restaurant revenue.',
  'promotionManagement.newPromotion.banner.description2':
    'Available for online ordering, branded App, QR code ordering, tablet, kiosk, and more.',

  'promotionManagement.newPromotion.disounts_on_order.title': 'Discounts on Order',
  'promotionManagement.newPromotion.disounts_on_order.description': 'Offer discounts on orders or reduce order costs.',
  'promotionManagement.newPromotion.disounts_on_order.order_discount': 'Order Discount',
  'promotionManagement.newPromotion.disounts_on_order.order_discount_desc':
    'Offer instant discounts: percentage-based or fixed-amount off.',
  'promotionManagement.newPromotion.disounts_on_order.min_spend': 'Min Spend, Order Discount',
  'promotionManagement.newPromotion.disounts_on_order.min_spend_desc':
    'Apply discounts when order reaches a set threshold: percentage-based or fixed-amount off.',

  'promotionManagement.newPromotion.disounts_for_featured_items.title': 'Discounts for Featured Items',
  'promotionManagement.newPromotion.disounts_for_featured_items.description':
    'Offer discounts on selected items or reduce prices on the items.',
  'promotionManagement.newPromotion.disounts_for_featured_items.item_discount': 'Items Discount',
  'promotionManagement.newPromotion.disounts_for_featured_items.item_discount_desc':
    'Offer instant discounts on selected items: percentage-based or fixed-amount off.',
  'promotionManagement.newPromotion.disounts_for_featured_items.min_spend': 'Min Spend, Items Discount',
  'promotionManagement.newPromotion.disounts_for_featured_items.min_spend_desc':
    'Apply discounts on select items when order reaches a set threshold: percentage-based or fixed-amount off.',

  'promotionManagement.newPromotion.BOGO.title': 'BOGO',
  'promotionManagement.newPromotion.BOGO.description':
    'After purchasing the items, you can enjoy discounts when you buy more items.',
  'promotionManagement.newPromotion.BOGO.buy_one_get_one': 'Buy One Get One',
  'promotionManagement.newPromotion.BOGO.buy_one_get_one_desc':
    'Discounts on additional items after purchasing selected items.',

  'promotionManagement.no_contracts.banner.title': 'Promotion Management',
  'promotionManagement.no_contracts.banner.description1':
    'Boost store performance by offering order discounts, featured item discounts, and BOGO promotions to drive order volume, increase average spending, and grow revenue.',
  'promotionManagement.no_contracts.banner.description2':
    'You have not purchased the Promotion Management service, please contact Chowbus customer success manager to order the service.',

  'promotionManagement.guide.title': 'Promotion Management',
  'promotionManagement.guide.desc1':
    'Boost store performance by offering order discounts, featured item discounts, and BOGO promotions to drive order volume, increase average spending, and grow revenue.',
  'promotionManagement.guide.desc2.prefix': 'You have not purchased the ',
  'promotionManagement.guide.desc2.highlight': 'Promotion Management',
  'promotionManagement.guide.desc2.suffix':
    ' service, please contact Chowbus customer success manager to order the service.',

  'promotionManagement.filter.search.date': 'Search by effective time',
  'promotionManagement.uploaded.phone_numbers': 'Uploaded. Total: {uploadedCount} mobile numbers.',
};
